import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

// Import Thesys C1 required CSS
import "@crayonai/react-ui/styles/index.css";

import { App } from "@app/core/App";
import { store } from "@app/redux/store";
import { theme } from "@app/theme";
import { startSentry } from "@app/core/thirdParty/sentry";
import { isDebugBuild } from "@app/const";

if (!isDebugBuild) {
  // Init 3rd Party
  startSentry();
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ThemeProvider>
        </StyledEngineProvider>
      </LocalizationProvider>
    </Provider>
  </React.StrictMode>,
);
